<template>
  <div
    v-show="notifications.length"
    ref="systemNotificationsRef"
    class="system-notifications"
  >
    <basic-message
      v-for="(notification, index) in notifications"
      :key="index"
      class="system-notification"
      :closeable="false"
      :severity="notification.level"
      :title-label="notification.text"
    />
  </div>
</template>

<script setup>
import { onBeforeMount, ref, watch } from 'vue'

import useI18n from '@/hooks/useI18n'
import useSystemNotifications from '@/hooks/useSystemNotifications'

import { BasicMessage } from '@/components/Basic'

// HOOKS
const { selectedLanguage } = useI18n()
const { getSystemNotifications } = useSystemNotifications()

// INIT
const props = defineProps({
  language: {
    type: String,
    required: true,
  },
})

// DATA
const notifications = ref([])

// LIFECYCLE HOOKS
onBeforeMount(async () => {
  notifications.value = await getSystemNotifications(props.language)
})

// WATCHER
watch(() => selectedLanguage.value, async value => {
  notifications.value = await getSystemNotifications(value)
})
</script>

<style scoped>
.system__notifications {
  position: relative;
  top: 0;
  width: 100%;
  z-index: var(--pet-stack-level-system-notification);
  transition: position 0.75s ease-in-out;
}
.message {
  border-radius: 0;
}

@media (--v-medium) {
  .system__notifications {
    position: sticky;
  }
  .section__header {
    padding-top: 0;
  }
}
</style>
